import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { FormEvent, useState } from "react";
import { AuthContextTypes } from "~/login/auth-context";
import { motion } from "motion/react";

export default function TotpInputForm({
  state,
  verifyMfaCodeForLogin,
  dispatch,
}: {
  state: AuthContextTypes["state"];
  verifyMfaCodeForLogin: (params: {
    verificationCode: string;
  }) => Promise<void>;
  dispatch: AuthContextTypes["dispatch"];
}) {
  const [verificationCode, setVerificationCode] = useState<string>();
  const mfaVerificationInProgress = state.status === "mfa verifying";

  const handleVerifyMfa = async (e: FormEvent) => {
    e.preventDefault();
    if (!verificationCode) {
      dispatch({ type: "error", error: "Please enter a verification code." });
      return;
    }
    await verifyMfaCodeForLogin({ verificationCode });
  };

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        p: 3,
        width: "100%",
        maxWidth: 500,
        minHeight: 350,
        textAlign: "center",
        background: "white",
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleVerifyMfa}
        sx={{ py: 5, px: 2, height: 200 }}
      >
        <Typography color="primary" sx={{ textAlign: "center", mb: 3 }}>
          Enter the verification code from your authenticator app
        </Typography>
        <Stack direction="row" gap={2}>
          <FormControl fullWidth>
            <InputLabel htmlFor="verification-code" sx={visuallyHidden}>
              Verification Code
            </InputLabel>
            <TextField
              type="text"
              autoComplete="one-time-code"
              fullWidth
              id="verification-code"
              label="Verification Code"
              aria-describedby="verification-code-error"
              onChange={(e) => setVerificationCode(e.target.value)}
              sx={{
                input: { color: "black" },
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
              }}
              error={Boolean(state.error)}
            />
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            loading={mfaVerificationInProgress}
            loadingPosition="start"
            sx={{
              alignSelf: "start",
              minWidth: 100,
              height: 55,
              "&.Mui-disabled": { backgroundColor: "#CCC" },
            }}
          >
            Verify
          </Button>
        </Stack>
        <FormHelperText error id="verification-code-error" aria-live="polite">
          {state.error}
        </FormHelperText>
      </Box>
    </Box>
  );
}
